import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { setActiveTab } from '../../actions/wetterAction';
import {MODIMAGEPATH} from '../api';
import Slider from "react-slick";
import Moment from 'react-moment';
import 'moment/locale/de';

function TopSection(props) {
    const dispatch = useDispatch();
    const active_tab = useSelector((store)=>store.wetter.active_tab);
    //console.log("reneder TopSection ", new Date().getMilliseconds());
    const wdata = useSelector((store)=>store.wetter[active_tab]);
    //console.log("wdata=",wdata);
    var sunrise = wdata?.singleday_wdata?.sunrise[0] ? wdata?.singleday_wdata?.sunrise[0].split('T') : [];
    const sunrise_time = (typeof sunrise[1] !== 'undefined') ? sunrise[1].split('+')[0] : '';

    var sunset = wdata?.singleday_wdata?.sunset[0] ? wdata?.singleday_wdata?.sunset[0].split('T') : [];
    const sunset_time = (typeof sunset[1] !== 'undefined') ? sunset[1].split('+')[0] : '';

    var slider_settings = {
        slidesToShow:11,
        slidesToScroll:11,
        swipeToSlide:true,
        focusOnSelect:true,
        infinite:false,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 11,
                slidesToScroll: 11
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 9,
                slidesToScroll: 9
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 7
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },

            {
              breakpoint: 300,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ]
    }

    return (
        <div className='wa_container'>
            <div className='notification_bar'>
                {wdata?.multiday_wdata?.Forecast_daily?.TextForecast[0]}
            </div>
            <div className='wa_row'>
                <div className='sect_right'>
                    <h6 className='curtemp'>{wdata?.singleday_wdata?.maxTemp[0]}°</h6>
                    <h6 className='betwtemp'>{wdata?.singleday_wdata?.minTemp[0]}°/{wdata?.singleday_wdata?.maxTemp[0]}°</h6>
                </div>
                <div className='sect_left'>
                    <h6 className='temparea'>
                        {
                            active_tab === 'tal' ?
                                props.accname
                            :
                                props.bergname    
                        }
                    </h6>
                    <h6 className='tempdate'>
                        <Moment format='DD. MMMM YYYY' locale={props.lang}>{wdata?.singleday_wdata?.sunrise[0]}</Moment>
                    </h6>
                    <div className='areaweth'>
                        <div className='areamn'>
                            <img src={MODIMAGEPATH+'svg/'+wdata?.singleday_wdata?.weatherIcon[0]+'.svg'} alt="" />
                            <p>{wdata?.singleday_wdata?.forecastShortText[0]}</p>                            
                        </div>
                        <div className='areamba'>
                            <div className="areon">
                                <img src={MODIMAGEPATH+'s1.png'} alt="" />
                                <p>{sunrise_time}</p>
                            </div>
                            <div className="areon">
                                <img src={MODIMAGEPATH+'s2.png'} alt="" />
                                <p>{sunset_time}</p>
                            </div>
                            <div className="areon">
                                <img src={MODIMAGEPATH+'s3.png'} alt="" />
                                <p>{wdata?.singleday_wdata?.sunshineDuration[0]} h</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='tbarea'>
                <ul>
                    <li className={active_tab === 'tal' ? 'active' : ''} onClick={()=>dispatch(setActiveTab('tal'))}>
                        <h6>Talwetter</h6>
                    </li>
                    {
                        props.berglat !== '' && props.berglon !== '' ?
                        <li className={active_tab === 'berg' ? 'active' : ''} onClick={()=>dispatch(setActiveTab('berg'))}>
                            <h6>Bergwetter</h6>
                        </li>
                        :<></>
                    }
                </ul>
                <div className='tbdata'>
                    <div className='tbitem'>
                        <Slider {...slider_settings} className="mySlicker">
                                {
                                    wdata.multiday_wdata !== null && Object.values(wdata?.multiday_wdata?.Forecast_hourly?.ForecastTimes_LocalTime).slice(0,24).map((time,index)=>{
                                        var forecast = wdata?.multiday_wdata?.Forecast_hourly;
                                        var iconsvg = MODIMAGEPATH+"svg/"+ forecast.Icon[index].replace(".png", ".svg");
                                        var datetime = time ? time.split('T') : [];
                                        var timehh_mm = (typeof datetime[1] !== 'undefined') ? datetime[1].split('+')[0] : '';
                                        var border = (index > 0 && timehh_mm === "00:00") ? 'borderleftin' : '';
                                        
                                        return (
                                            <div className={'swiper-slide '+border} key={index}>
                                                <h6>{timehh_mm}</h6>
                                                <img src={iconsvg} alt="" />
                                                <h3>{forecast.Temperature[index]}°</h3>
                                                <p>{forecast.WindSpeed[index]} km/h</p>
                                                <span>
                                                    {forecast.WindDirection[index]}
                                                </span>
                                            </div>
                                        );
                                    })
                                }
                        </Slider> 
                    </div>
                </div>
            </div>
            <div className="wettlarge_metgis">
                <a rel='noreferrer' target="_blank" href="https://www.fullmarketing.at/kompetenzen/webdesign/website-wetter"> 
                    {
                        props.lang === 'de' ?
                            <>Tool von <b>fullmarketing.at</b> |  Wetterdaten von <b>MetGIS</b></>
                        :
                            <>Tool by <b>fullmarketing.at</b> |  Weatherdata by <b>MetGIS</b></>
                    }
                </a>
            </div>
        </div>
    );
}

export default TopSection;